import { SelectionState } from 'draft-js';

/**
 * Must be called with `this` bound to TextBlock.
 */
export default function findLinkEntitiesStrategy(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(
    (character) => {
      // Fix "Uncaught TypeError: Cannot read property 'getEntity' of undefined"
      if (!character) {
        return false;
      }

      const entityKey = character.getEntity();

      return (
        entityKey !== null &&
        contentState.getEntity(entityKey).getType() === 'LINK'
      );
    },

    (start, end) => {
      const handleClick = () => {
        if (this && this.linkAddElement) {
          const newSelectionState = new SelectionState({
            anchorKey: contentBlock.getKey(),
            anchorOffset: start,
            focusKey: contentBlock.getKey(),
            focusOffset: end,
          });

          this.handleSelectionChange(newSelectionState);
          this.linkAddElement.openPopover();
        }
      };

      const props = {
        onClick: handleClick,
      };

      callback(start, end, props);
    }
  );
}
